import { LabMessage } from "../Models/LabMessage";
import { LabReportProcessingStatusComponent } from "./LabReportProcessingStatusComponent";
import { LabReportReadingStatusComponent } from "./LabReportReadingStatusComponent";

import styles from "./LabReportCombinedStatusComponent.module.scss";

interface LabReportStatusComponentProps {
    LabMessage: LabMessage;
}

function LabReportCombinedStatusComponent({ LabMessage }: Readonly<LabReportStatusComponentProps>): JSX.Element {
    return (
        <div className={styles.labReportCombinedStatusContainer}>
            <LabReportProcessingStatusComponent labStatus={LabMessage.Model.LabProcessingStatus} />
            <LabReportReadingStatusComponent LabMessage={LabMessage} />
        </div>

    );
}

export { LabReportCombinedStatusComponent };
